import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';


export interface MessageDialogData {
  title: string;
  message: string;
  messageParams?: {
    examName?: string;
    examStartDelay?: string;
  }
  actions: MessageDialogAction[];
}

export interface MessageDialogAction {
  title: string;
  color: MessageDialogActionColor;
  handler: (action: MessageDialogAction) => void;
}

export enum MessageDialogActionColor {
  Primary = 'primary',
  None = ''
}

@Component({
    selector: 'asg-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, TranslateModule]
})
export class MessageDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData,
    private dialogRef: MatDialogRef<MessageDialogComponent>
  ) { }

  onActionClick(action: MessageDialogAction): void {
    this.dialogRef.close();
    action.handler(action);
  }
}
